import { useEffect, useState } from 'react';
import { FaSmile} from 'react-icons/fa';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Spinner from '../utils/Spinner';
import { setLoading } from '../redux/product/productSlice';
import { setOrderDetails } from '../redux/features/auth/userSlice';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import api from '../axios/axios';
import OrderInfo from '../components/orderDetails/OrderInfo';
import TrackingStepper from '../components/orderDetails/TrackingStepper';
import OrderItems from '../components/orderDetails/OrderItems';
import OrderSummary from '../components/orderDetails/OrderSummary';
import CompleteOrderDetails from '../components/orderDetails/CompleteOrderDetails';
import ShippingInfo from '../components/orderDetails/ShippingInfo';
import AttributeModal from '../components/orderDetails/AttributeModal';
import TaxDetailsModal from '../components/orderDetails/TaxDetailsModal';

// Define utility functions within the file
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const formatCurrency = (amount) => {
  return (Number(amount) / 100).toFixed(2);
};

const UserOrderPage = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.user.currentUser);
  const loading = useSelector((state) => state.user.loading);
  const { id } = useParams();
  const order = useSelector((state) => state.user.order);

  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [isAttributeModalOpen, setIsAttributeModalOpen] = useState(false);
  const [selectedTaxes, setSelectedTaxes] = useState([]);
  const [isTaxModalOpen, setIsTaxModalOpen] = useState(false);

  useEffect(() => {
    if (id) fetchOrderDetails(id);
  }, [id]);

  const fetchOrderDetails = async (id) => {
    dispatch(setLoading(true));
    try {
      const response = await api.get(`user/fetchOrderDetails/${id}`, { params: { userId: currentUser._id } });
      dispatch(setOrderDetails(response.data.order));
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const openAttributeModal = (attributes) => {
    setSelectedAttributes(attributes);
    setIsAttributeModalOpen(true);
  };

  const openTaxModal = (taxes) => {
    setSelectedTaxes(taxes);
    setIsTaxModalOpen(true);
  };

  if (loading) return <div><Spinner /></div>;

  if (!order || !order._id) return (
    <div className="text-center p-8 bg-gray-50 rounded-lg shadow-md">
      <FaSmile className="text-5xl text-gray-400 mb-4" />
      <h2 className="text-xl font-semibold">No Order Found</h2>
      <p className="text-gray-600">It looks like this order does not exist.</p>
    </div>
  );

  return (
    <>
      <Navbar />
      <div className="bg-gray-100 min-h-screen py-20">
        <div className="max-w-6xl mx-auto bg-white shadow-xl rounded-lg p-6 md:p-8">
          <h1 className="text-3xl font-semibold text-secondary mb-6 border-b-2 border-primary pb-2">Order Details</h1>
          <OrderInfo order={order} formatDate={formatDate} />
          <TrackingStepper status={order.status} />
          <h3 className="text-xl font-semibold text-secondary mb-4">Order Items</h3>
          <OrderItems items={order.items} openAttributeModal={openAttributeModal} openTaxModal={openTaxModal}        fetchOrderDetails={fetchOrderDetails}
 />
          <OrderSummary order={order} formatCurrency={formatCurrency} />
          <CompleteOrderDetails order={order} formatDate={formatDate} formatCurrency={formatCurrency} />
          <ShippingInfo order={order} />
        </div>
      </div>
      <AttributeModal
        isOpen={isAttributeModalOpen}
        onClose={() => setIsAttributeModalOpen(false)}
        attributes={selectedAttributes}
        formatCurrency={formatCurrency}
      />
      <TaxDetailsModal
        isOpen={isTaxModalOpen}
        onClose={() => setIsTaxModalOpen(false)}
        taxes={selectedTaxes}
        formatCurrency={formatCurrency}
      />
      <Footer />
    </>
  );
};

export default UserOrderPage;